module.exports = __webpack_public_path__ + "img/2015007.89ef12e1.svg";